import { useContentOverflow } from '../../../../../hooks'
import { FloatingTooltip } from '../../../../Floating'
import Text from '../../../../Text'

import * as styles from './OverviewViewingText.module.css'

function OverviewViewingText({
  className = styles.OverviewViewingText,
  qaName,
  text,
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow({
    dep: [text],
  })

  return (
    <FloatingTooltip content={text} disabled={!overflow}>
      <Text className={className} qaName={qaName} ref={setContentOverflowRef}>
        {text}
      </Text>
    </FloatingTooltip>
  )
}

export default OverviewViewingText
